import React, { Children } from 'react';

export enum ContentContainerType {
    Div,
    Paragraph
}

export interface ContentContainerProps {
    type?: ContentContainerType // default is div
}

export class ContentContainer extends React.PureComponent<ContentContainerProps> {
    public render() {
        return (this.props.type ?? ContentContainerType.Div) === ContentContainerType.Div
            ? <div className="start-subcontent-content-container">{this.props.children}</div>
            : <p className="start-subcontent-content-container">{this.props.children}</p>
    }
}

